"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nextState = exports.nextMoves = exports.nextApple = exports.nextSnake = exports.nextHead = exports.willCrash = exports.willEat = void 0;
var ramda_1 = require("ramda");
var utils_1 = require("./utils");
var constants_1 = require("./constants");
exports.willEat = function (state) {
    return ramda_1.equals(exports.nextHead(state), state.frame.apple);
};
exports.willCrash = function (state) {
    return ramda_1.includes(exports.nextHead(state), ramda_1.drop(1, exports.nextSnake(state)));
};
exports.nextHead = function (_a) {
    var _b = _a.frame, snake = _b.snake, dimensions = _b.dimensions, moves = _a.moves;
    return ({
        x: utils_1.scopeValue(0, dimensions.cols - 1)(snake[0].x + moves[0].x),
        y: utils_1.scopeValue(0, dimensions.rows - 1)(snake[0].y + moves[0].y),
    });
};
exports.nextSnake = function (state) {
    return ramda_1.cond([
        [
            ramda_1.pathOr(false, ['frame', 'hasSnakeCrashed']),
            ramda_1.pipe(ramda_1.pathOr([], ['frame', 'snake']), ramda_1.when(ramda_1.propSatisfies(ramda_1.gt(ramda_1.__, 1), 'length'), ramda_1.curry(ramda_1.dropLast)(1))),
        ],
        [exports.willEat, ramda_1.converge(ramda_1.insert(0), [exports.nextHead, ramda_1.pathOr([], ['frame', 'snake'])])],
        [
            ramda_1.T,
            ramda_1.converge(ramda_1.insert(0), [
                exports.nextHead,
                ramda_1.pipe(ramda_1.pathOr([], ['frame', 'snake']), ramda_1.curry(ramda_1.dropLast)(1)),
            ]),
        ],
    ])(state);
};
exports.nextApple = function (state) {
    return exports.willEat(state) ? utils_1.getRandomPixel(state.frame.dimensions) : state.frame.apple;
};
exports.nextMoves = function (inputs) { return function (state) {
    return state.frame.hasSnakeCrashed
        ? [constants_1.MOVES['STOPPED']]
        : ramda_1.pipe(ramda_1.concat(ramda_1.__, ramda_1.pipe(ramda_1.map(utils_1.inputToMove), ramda_1.when(ramda_1.always(ramda_1.propEq('length', 1, state.moves)), // Whenever the inputs are the incoming moves
        utils_1.removeIncomingOppositeMoves(utils_1.getFirst(state.moves))))(inputs)), ramda_1.when(ramda_1.propSatisfies(ramda_1.gt(ramda_1.__, 1), 'length'), ramda_1.drop(1)))(state.moves);
}; };
exports.nextState = function (state, inputs) {
    return ramda_1.applySpec({
        frame: {
            hasSnakeCrashed: ramda_1.converge(ramda_1.or, [
                ramda_1.path(['frame', 'hasSnakeCrashed']),
                exports.willCrash,
            ]),
            snake: exports.nextSnake,
            apple: exports.nextApple,
            dimensions: ramda_1.path(['frame', 'dimensions']),
            score: ramda_1.ifElse(exports.willEat, ramda_1.pipe(ramda_1.pathOr(0, ['frame', 'score']), ramda_1.inc), ramda_1.pathOr(0, ['frame', 'score'])),
        },
        moves: exports.nextMoves(inputs),
    })(state);
};
